module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKIEITD.6d7dff9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKIEITD.png
// module id = 67
// module chunks = 0